import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatoryIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M10.7628 2H7.23781C6.45781 2 5.82031 2.63 5.82031 3.41V4.115C5.82031 4.895 6.45031 5.525 7.23031 5.525H10.7628C11.5428 5.525 12.1728 4.895 12.1728 4.115V3.41C12.1803 2.63 11.5428 2 10.7628 2Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M12.9312 4.11511C12.9312 5.30761 11.9563 6.28261 10.7638 6.28261H7.23875C6.04625 6.28261 5.07125 5.30761 5.07125 4.11511C5.07125 3.69511 4.62125 3.43261 4.24625 3.62761C3.18875 4.19011 2.46875 5.30761 2.46875 6.59011V13.6476C2.46875 15.4926 3.97625 17.0001 5.82125 17.0001H12.1812C14.0262 17.0001 15.5337 15.4926 15.5337 13.6476V6.59011C15.5337 5.30761 14.8138 4.19011 13.7563 3.62761C13.3813 3.43261 12.9312 3.69511 12.9312 4.11511ZM9.28625 13.2126H6.00125C5.69375 13.2126 5.43875 12.9576 5.43875 12.6501C5.43875 12.3426 5.69375 12.0876 6.00125 12.0876H9.28625C9.59375 12.0876 9.84875 12.3426 9.84875 12.6501C9.84875 12.9576 9.59375 13.2126 9.28625 13.2126ZM11.2513 10.2126H6.00125C5.69375 10.2126 5.43875 9.95761 5.43875 9.65011C5.43875 9.34261 5.69375 9.08761 6.00125 9.08761H11.2513C11.5588 9.08761 11.8138 9.34261 11.8138 9.65011C11.8138 9.95761 11.5588 10.2126 11.2513 10.2126Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_3)
  ]))
}
}

})